import React, { memo, useMemo } from 'react';
import { LabelType, MyAnalyticsDimensionType } from 'graphql/types';
import { useGetMyAnalyticsData } from 'modules/Insights/Notes/hooks/useGetMyAnalyticsData';
import { transformLabelData } from './utils';
import ProjectComponent from './ProjectComponent';

export const ProjectChart: React.FC = () => {
  const { data, loading = true, isEmpty } = useGetMyAnalyticsData(
    MyAnalyticsDimensionType.MetricsByProject
  );
  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.myAnalytics?.items, LabelType.Project);
    }
  }, [data?.myAnalytics?.items, isEmpty]);

  return (
    <ProjectComponent data={dataset} loading={loading} isEmpty={isEmpty} />
  );
};
export default memo(ProjectChart);
